<template>
  <div style="height: 200px">
    我要通关详情页页面
    <!-- Employee Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// DoClearanceDetail.vue?26add82a